export default "__VITE_ASSET__C0BUl0fY__"